

exports.__esModule = true;
exports.$xoShippingComponent = undefined;

var _squid = require('squid');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('xo-member-components/src/select-shipping/directive');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoShippingComponent = exports.$xoShippingComponent = _squid.$Component.extend('$xoShippingComponent', {
    tag: 'xo-shipping',
    template: _template2['default'],

    controller: function controller($scope, $rootScope, $location) {
        $scope.token = $rootScope.token;
        $scope.onComplete = function (result) {
            $location.path('/checkout/review');
        };
    }
});

angular.value("$xoShippingComponent", $xoShippingComponent);
_squid.$Component;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-shipping/directive.js
// module id = ./pages/xo-shipping/directive.js
// module chunks = 1